import { Request } from '~src/httpClient/serverApi/requests/Request';
import {IResult} from '~src/httpClient/serverApi/types/IResponse';


export interface IDeactivateSiteEncryptionKeyParams {
  externalKeyId: string;
}

export interface DeactivateSiteEncryptionKeyResult extends IResult {}

export class DeactivateSiteEncryptionKeyRequest extends Request<IDeactivateSiteEncryptionKeyParams, DeactivateSiteEncryptionKeyResult> {
  constructor(params: IDeactivateSiteEncryptionKeyParams) {
    super('deactivateSiteEncryptionKey', params);
  }
}